module.exports = __webpack_public_path__ + "img/notes.ca16fd34.png";